import { Dispatch, Fragment, SetStateAction, useCallback, useEffect } from 'react';

import { Table } from 'CorePackage/TableModule/components/Table';
import { ITableColumn } from 'CorePackage/TableModule/interfaces/ITableColumn';
import { TableCheckItems } from 'CorePackage/MainModule/types/TableCheckItems';
import { handleSortChange } from 'CorePackage/MainModule/common/handleSortChange';
import { ROUTE_PREVENTION, ROUTE_SIMILARITIES } from 'CorePackage/MainModule/routes/routes';
import { num2str } from 'CorePackage/MainModule/common/num2str';
import { ConfirmModal } from 'UIPackage/MainModule/components/ConfirmModal';

import styles from './KnmListTable.module.scss';
import { IKnmRaw } from '../interfaces/IKnmRaw';

interface IKnmListTableProps {
  tableColumns: ITableColumn<IKnmRaw>[];
  itemsCheck?: TableCheckItems;
  knms: IKnmRaw[];
  totalCount?: number;
  isConfirmModalVisible?: boolean;
  setItemsCheck?: Dispatch<SetStateAction<TableCheckItems>>;
  setTableColumns?: Dispatch<SetStateAction<ITableColumn<IKnmRaw>[]>>;
  handleLoadClick?: () => void;
  onChangeSort?: (newColumnsData: ITableColumn<IKnmRaw>[]) => void;
  handleSettingsButtonClick?: () => void;
  handleDeleteClick?: () => void;
  handleDeleteModalClose?: () => void;
  checkedNames?: string[];
}

export const KnmListTable = ({
  tableColumns,
  itemsCheck,
  knms,
  totalCount,
  isConfirmModalVisible,
  setItemsCheck,
  setTableColumns,
  handleLoadClick,
  handleSettingsButtonClick,
  onChangeSort,
  handleDeleteClick,
  handleDeleteModalClose,
  checkedNames = ['КНМ', 'КНМ', 'КНМ'],
}: IKnmListTableProps) => {
  const deletingTemplatesNumber = Object.keys(itemsCheck || {}).filter(key => (itemsCheck ? itemsCheck[key] : false))
    .length;
  const deletingQuantityText = num2str(deletingTemplatesNumber, ['запись', 'записи', 'записей']);

  useEffect(() => {
    const newItemsCheck: TableCheckItems = {};

    knms.forEach(item => {
      if (item?.id) {
        newItemsCheck[item.id] = false;
      }
    });
    setItemsCheck && setItemsCheck(newItemsCheck);
  }, [knms, setItemsCheck]);

  const handleSortClick = useCallback(
    (id: keyof IKnmRaw) => {
      const newColumnsData = handleSortChange(tableColumns, id);

      setTableColumns?.(newColumnsData);
      onChangeSort?.(newColumnsData);
    },
    [onChangeSort, setTableColumns, tableColumns],
  );

  return (
    <Fragment>
      <Table<IKnmRaw>
        columns={tableColumns}
        itemsCheck={itemsCheck}
        data={knms}
        setItemsCheck={setItemsCheck}
        onSortChange={handleSortClick}
        columnStyles={styles}
        isPm={window.location.pathname.includes(ROUTE_PREVENTION)}
        headPlacement={window.location.pathname.includes(ROUTE_SIMILARITIES) ? 'centre' : undefined}
        checkedNames={checkedNames}
        handleLoadClick={handleLoadClick}
        totalCount={totalCount}
        onSettingsButtonClick={handleSettingsButtonClick}
      />
      {handleDeleteClick && handleDeleteModalClose && (
        <ConfirmModal
          visible={isConfirmModalVisible}
          title="Подтверждение"
          text={`Вы выбрали ${deletingTemplatesNumber} ${deletingQuantityText} для удаления. Удалить?`}
          applyButtonText="Удалить"
          cancelButtonText="Отменить"
          onApply={handleDeleteClick}
          onClose={handleDeleteModalClose}
        />
      )}
    </Fragment>
  );
};
